import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/product/ProductBuyBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/product/ProductGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/components/SafeImage.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/akustikpanel.tr/node_modules/next/dist/client/link.js");
